module.exports = "https://static.wmbcdn.com/uniweb/images/b8b416f6a551b4369ae968607a5bd9ff.svg";